import { z } from 'zod';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { GenderType } from '@/model';
import { t } from '@/i18n';

export const modalFormSchema = z.object({
  first_name: z.string().min(1, t('pages.accountdetail.components.tabs.personal_data_tab.schema.required')),
  last_name: z.string().min(1, t('pages.accountdetail.components.tabs.personal_data_tab.schema.required')),
  document: z
    .string()
    .min(1, t('pages.accountdetail.components.tabs.personal_data_tab.schema.required'))
    .refine(value => {
      return cpf.isValid(value) || cnpj.isValid(value);
    }, t('pages.accountdetail.components.tabs.personal_data_tab.schema.invalid.document')),
  nickname: z.string().min(1, t('pages.accountdetail.components.tabs.personal_data_tab.schema.required')),
  birthdate: z.string().min(1, t('pages.accountdetail.components.tabs.personal_data_tab.schema.required')),
  gender: z.enum([GenderType.FEMALE, GenderType.MALE, GenderType.NO_ANSWER, GenderType.OTHER]).default(GenderType.NO_ANSWER),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
